import MentionFormat from './MentionFormat';
import UserMention from '../UserMention';
import PostMention from '../PostMention';
import GroupMention from '../GroupMention';
export default class AtMentionFormat extends MentionFormat {
  mentionables = (() => [UserMention, PostMention, GroupMention])();
  extendable = true;
  trigger() {
    return '@';
  }
  queryFromTyped(typed) {
    const matchTyped = typed.match(/^["“]?((?:(?!"#).)+)$/);
    return matchTyped ? matchTyped[1] : null;
  }
  format(name, char, id) {
    if (char === void 0) {
      char = '';
    }
    if (id === void 0) {
      id = null;
    }
    return {
      simple: `@${name}`,
      safe: `@"${name}"#${char}${id}`
    }[id ? 'safe' : 'simple'];
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/AtMentionFormat', AtMentionFormat);